"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closureApply = void 0;
const env_1 = require("../env");
const evaluate_1 = require("../evaluate");
function closureApply(closure, arg) {
    switch (closure["@kind"]) {
        case "ClosureSimple": {
            return (0, evaluate_1.evaluate)((0, env_1.EnvCons)(closure.name, arg, closure.env), closure.body);
        }
        case "ClosureNative": {
            return closure.native(arg);
        }
    }
}
exports.closureApply = closureApply;
//# sourceMappingURL=closureApply.js.map